import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { Bell, Lock, LinkSimple, ShieldCheck, Storefront, type Icon as PhosphorIcon } from '@phosphor-icons/react';
import { Icon } from '../../../../../components/Icon';
import { cx } from '../../../../../lib/cx';

export const Route = createFileRoute('/subdomain/app/_client/settings')({
  component: SettingsLayout,
});

interface SettingsNavItem {
  label: string;
  icon: PhosphorIcon;
  /** Omitted = not built yet (later sprints): shown, per the design, but not a link. */
  to?: '/subdomain/app/settings/profile' | '/subdomain/app/settings/security' | '/subdomain/app/settings/notifications';
}

const NAV: SettingsNavItem[] = [
  { label: 'Profile & business', icon: Storefront, to: '/subdomain/app/settings/profile' },
  { label: 'Security', icon: ShieldCheck, to: '/subdomain/app/settings/security' },
  { label: 'Notifications', icon: Bell, to: '/subdomain/app/settings/notifications' },
  { label: 'Connected accounts', icon: LinkSimple },
  { label: 'Privacy & data', icon: Lock },
];

const ITEM =
  'flex items-center gap-(--mbm-space-3) rounded-(--mbm-radius-sm) px-(--mbm-space-4) py-(--mbm-space-3) text-label-large whitespace-nowrap focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring)';

function SettingsLayout() {
  return (
    <main className="flex flex-col gap-(--mbm-space-6) px-(--mbm-space-4) py-(--mbm-space-6) lg:px-(--mbm-space-9) lg:py-(--mbm-space-7)">
      <h1 className="text-display text-text-strong">Settings</h1>

      <div className="flex flex-col gap-(--mbm-space-6) lg:flex-row lg:gap-(--mbm-space-7)">
        <nav aria-label="Settings" className="shrink-0 lg:w-(--mbm-layout-settings-nav-width)">
          <ul className="flex gap-(--mbm-space-1) overflow-x-auto lg:flex-col">
            {NAV.map((item) => (
              <li key={item.label}>
                {item.to ? (
                  <Link
                    to={item.to}
                    activeProps={{
                      className: 'bg-surface-card text-text-primary shadow-(--mbm-shadow-sm)',
                      'aria-current': 'page',
                    }}
                    inactiveProps={{ className: 'text-text-secondary hover:text-text-primary' }}
                    className={ITEM}
                  >
                    <Icon icon={item.icon} size="md" />
                    {item.label}
                  </Link>
                ) : (
                  <span
                    aria-disabled="true"
                    title="Coming soon"
                    className={cx(ITEM, 'cursor-not-allowed text-text-tertiary')}
                  >
                    <Icon icon={item.icon} size="md" />
                    {item.label}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex min-w-0 max-w-(--mbm-layout-settings-content-width) flex-1 flex-col gap-(--mbm-space-6)">
          <Outlet />
        </div>
      </div>
    </main>
  );
}
